module.exports = "/static/assets/a4b63c1ef33148c23143a457fdc45bfc.png";